

export interface Address {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zipCode: string;
  country?: string;
  latitude?: number;
  longitude?: number;
}

export const formatAddress = (address: Address | null | undefined): string => {
  if (!address) return 'Address not available';

  if (!address.address1) return '';

  const { address1, address2, city, state, zipCode } = address;
  return `${address1}${address2 ? `, ${address2}` : ''}, ${city}, ${state} ${zipCode}`;
};

export const parseAddress = (fullAddress: string): Address => {
  const parts = fullAddress.split(',').map(part => part.trim());
  return {
    address1: parts[0] || '',
    city: parts[1] || '',
    state: parts[2]?.split(' ')[0] || '',
    zipCode: parts[2]?.split(' ')[1] || '',
  };
};


export const ensureAddressObject = (address: string | Address): Address => {
  if (typeof address === 'string') {
    return convertToAddressObject(address);
  }
  return address;
};

export const convertToAddressObject = (addressString: string): Address => {
  const parts = addressString.split(',').map(part => part.trim());
  return {
    address1: parts[0] || '',
    city: parts[1] || '',
    state: parts[2]?.split(' ')[0] || '',
    zipCode: parts[2]?.split(' ')[1] || '',
  };
};
